import { COLORS } from 'helpers/globals'

export default {
  bold: {
    fontWeight: 'bolder',
    color: 'black',
    marginRight: '1rem'
  },
  locationLink: {
    textDecoration: 'underline'
  },
  locationEdit: {
    marginLeft: '.5rem'
  },
  textarea: {
    margin: '1rem 0',
    minHeight: '7rem',
    resize: 'none'
  },
  copyButton: {
    width: '100%',
    fontSize: '1.4rem',
    margin: '.8rem 0',
  }
}



// WEBPACK FOOTER //
// ./src/components/DeviceDescription/style.js